// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"766":"f45de6ba","800":"fc1e9e20","855":"363dd771","964":"8cf4a270"}[chunkId] + ".chunk.css";
};